import BaseListPage from "../../../../../base/BaseListPage";
import dialog from "../../../../../components/Modal/dialog";
import PageContainer from "../../../../../components/PageContainer/PageContainer";
import Search from "../../../../../components/Search";
import Table from "../../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import withRouter from "../../../../../utils/withRouter";
import ProfileListPresenter from "./ProfileListPresenter";
import Select from "react-select";
import * as XLSX from "xlsx-js-style";

class ProfileListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ProfileListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      upsertUseCase(),
      deleteObjectUseCase(),
    );

    this.fieldsToDisplay = [
      "username",
      "branch",
      "affiliate",
      "status",
      "approvedBy",
    ];

    this.state = {
      ...this.state,
      affiliates: [],
      selectedAffiliate: null,
      exporting: false,
    };
  }

  componentDidMount() {
    this.presenter.componentDidMount();
    findObjectUseCase()
      .execute("affiliates", { keys: ["name", "code"], sort: { name: 1 } })
      .then((affiliates) => this.setState({ affiliates }))
      .catch(console.error);
  }

  onSelectAffiliate(option) {
    this.setState({ selectedAffiliate: option });
    this.presenter.onSelectAffiliate(option ? option.value : null);
  }

  setExporting(value) {
    this.setState({ exporting: value });
  }

  onExportReady(data) {
    const formatDate = (value) => {
      if (!value) return "";
      const d = new Date(value);
      if (isNaN(d.getTime())) return "";
      return d.toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    };
    const rows = data.map((u) => ({
      "Full Name":
        `${u.firstName || ""} ${u.middleName || ""} ${u.lastName || ""}`.trim(),
      Username: u.username || "",
      Email: u.email || "",
      "Mobile Number": u.mobileNumber || "",
      Affiliate: `${u.affiliate?.name}` || "",
      Branch: u.branch?.code || "",
      Position: u.position || "",
      Department: u.department || "",
      Status: u.status || "",
      "Registration Status": u.registrationStatus || "",
      "Start Date": formatDate(u.createdAt),
      "Last Login": formatDate(u.last_login_at),
    }));

    if (rows.length === 0) return;

    const headers = Object.keys(rows[0]);
    const wsData = [headers, [], ...rows.map((row) => Object.values(row))];

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    headers.forEach((_, idx) => {
      const cell = XLSX.utils.encode_cell({ r: 0, c: idx });
      if (ws[cell]) {
        ws[cell].s = {
          font: { bold: true },
          alignment: { horizontal: "center" },
        };
      }
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Users");
    XLSX.writeFile(wb, "users_export.xlsx");
  }

  getCollectionName() {
    return "users";
  }

  formatSchema(fields) {
    return {
      ...fields,
      fullName: {
        type: "String",
        label: "Full Name",
      },
      approvedBy: {
        type: "String",
        label: "Approved By",
      },
      affiliate: {
        type: "String",
        label: "Client Code",
      },
      branch: {
        type: "String",
        label: "Branch Code",
      },
      status: {
        ...fields.status,
      },
      username: {
        ...fields.username,
        _type: "String",
      },
    };
  }

  formatObjects(objects) {
    return objects.map((object) => {
      return {
        ...object,
        fullName: `${object?.firstName} ${object?.middleName || ""} ${
          object?.lastName
        }`,
        affiliate: object.affiliate?.code,
        branch: object.branch?.code,
        approvedBy: `${object.approvedBy?.firstName || ""} ${
          object.approvedBy?.middleName || ""
        } ${object.approvedBy?.lastName || ""}`,
      };
    });
  }

  onClickActive(index) {
    this.presenter.onClickActive(index);
  }

  onClickDelete(index) {
    const user = this.state.objects[index];
    const fullName =
      `${user?.firstName || ""} ${user?.middleName || ""} ${user?.lastName || ""}`.trim() ||
      user?.username ||
      "this user";

    dialog.fire({
      html: (
        <div className="text-center p-2">
          <i
            className="bi bi-exclamation-triangle-fill text-danger"
            style={{ fontSize: "2.5rem" }}
          />
          <h5 className="mt-3 fw-semibold">Delete User</h5>
          <p className="text-muted mb-0">
            Are you sure you want to delete{" "}
            <span className="fw-semibold text-dark">{fullName}</span>?
          </p>
          <p className="text-muted" style={{ fontSize: ".8rem" }}>
            This action cannot be undone.
          </p>
        </div>
      ),
      onPositiveClick: () => this.presenter.onClickDelete(index),
      onNegativeClick: () => {},
    });
  }

  searchSubmit(where, merge) {
    this.presenter.searchSubmit(where, merge);
  }

  onClickUserLogs(index) {
    const user = this.state.objects[index];
    this.navigateTo(`user-logs/${user.id}`);
  }

  onClickDeactivate(index) {
    const user = this.state.objects[index];
    const fullName =
      `${user?.firstName || ""} ${user?.middleName || ""} ${user?.lastName || ""}`.trim() ||
      user?.username ||
      "this user";

    dialog.fire({
      html: (
        <div className="text-center p-2">
          <i
            className="bi bi-exclamation-triangle-fill text-danger"
            style={{ fontSize: "2.5rem" }}
          />
          <h5 className="mt-3 fw-semibold">Deactivate User</h5>
          <p className="text-muted mb-0">
            Are you sure you want to Deactivate{" "}
            <span className="fw-semibold text-dark">{fullName}</span>?
          </p>
          <p className="text-muted" style={{ fontSize: ".8rem" }}>
            This action cannot be undone.
          </p>
        </div>
      ),
      onPositiveClick: () => this.presenter.onClickDelete(index, user),
      onNegativeClick: () => {},
    });
  }

  getActions(status) {
    return [
      {
        label: status,
        onClick: this.onClickActive.bind(this),
        icon: "",
        classes: status === "Active" ? "btn-secondary" : "btn-light",
      },
      {
        label: "Edit",
        onClick: this.onClickItem.bind(this),
        icon: "bi bi-pencil-square",
      },
      // {
      //   label: "Delete",
      //   onClick: this.onClickDelete.bind(this),
      //   icon: "bi bi-trash",
      //   classes: "btn-danger",
      // },
      {
        label: "Deactivate",
        onClick: this.onClickDeactivate.bind(this),
        icon: "bi bi-person-x",
        classes: "btn-danger",
      },
      {
        label: "User Logs",
        onClick: this.onClickUserLogs.bind(this),
        icon: "bi bi-list",
        classes: "btn-success",
      },
    ];
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());

    const {
      objects,
      loading,
      count,
      affiliates,
      selectedAffiliate,
      exporting,
    } = this.state;

    const affiliateOptions = affiliates.map((a) => ({
      value: a.id || a.code,
      label: `${a.name} (${a.code})`,
    }));

    return (
      <PageContainer
        title="Users"
        buttonHandler={this.onClickAdd.bind(this)}
        infiniteScroll={{
          loadMore: this.loadMore.bind(this),
          hasMore: !loading && count > objects.length,
        }}
      >
        <div className="d-flex flex-column gap-4">
          <div className="d-flex flex-row align-items-center justify-content-between gap-3">
            <div className="d-flex flex-row align-items-center gap-3">
              <div style={{ minWidth: 280 }}>
                <Select
                  isClearable
                  placeholder="Filter by affiliate..."
                  options={affiliateOptions}
                  value={selectedAffiliate}
                  onChange={this.onSelectAffiliate.bind(this)}
                />
              </div>
              <Search
                schemas={this.getSchemas()}
                onSubmit={this.searchSubmit.bind(this)}
                fields={{ username: { type: "string" } }}
                placeholder="Search by username"
              />
            </div>
            <button
              className="btn btn-secondary"
              disabled={exporting}
              onClick={() => this.presenter.exportCSV()}
            >
              {exporting ? "Exporting..." : "Export CSV"}
            </button>
          </div>
          <Table
            fields={this.formatSchema(schema.fields)}
            objects={this.formatObjects(objects)}
            collapsable
            progress={loading}
            actions={this.getActions.bind(this)}
            excludeFields={Object.keys(schema.fields).filter(
              (key) => !this.fieldsToDisplay.includes(key),
            )}
          />
        </div>
      </PageContainer>
    );
  }
}

export default withRouter(ProfileListPage);
